import React, { useCallback } from "react";
import PropTypes from "prop-types";

import { CSSTransition, TransitionGroup } from "react-transition-group";

import { getServiceOptions as getServiceOptionsUtil } from "../utils";

import TimesheetRow from "./TimesheetRow";

const TimesheetList = ({
  rows,
  customers,
  services,
  user,
  users,
  projects,
  contracts,
  auth,
  onChange,
  onChangeInput,
  onEnterCallDetails,
  onShowProjectDetails
}) => {
  const getServiceOptions = useCallback(
    (idx) =>
      getServiceOptionsUtil({
        project: rows[idx][`project ${idx}`],
        customer: rows[idx][`customer ${idx}`],
        users,
        user,
        customers,
        projects,
        services
      }),
    [customers, rows, services, user, users, projects]
  );

  return (
    <React.Fragment>
      <TransitionGroup className="timesheet-row-list">
        {rows.map((row, i) => (
          <CSSTransition
            key={i}
            timeout={500}
            classNames="timesheet-row-list-item"
          >
            <TimesheetRow
              row={row}
              idx={i}
              customers={customers}
              projects={projects}
              contracts={contracts}
              auth={auth}
              onChange={onChange}
              getServiceOptions={getServiceOptions}
              onChangeInput={onChangeInput}
              onEnterCallDetails={onEnterCallDetails}
              onShowProjectDetails={onShowProjectDetails}
            />
          </CSSTransition>
        ))}
      </TransitionGroup>
    </React.Fragment>
  );
};

TimesheetList.propTypes = {
  rows: PropTypes.array,
  customers: PropTypes.array,
  projects: PropTypes.array,
  contracts: PropTypes.array,
  auth: PropTypes.object,
  onChange: PropTypes.func,
  onChangeInput: PropTypes.func,
  onEnterCallDetails: PropTypes.func,
  services: PropTypes.array,
  user: PropTypes.string,
  users: PropTypes.array,
  onShowProjectDetails: PropTypes.func
};
export default TimesheetList;
